/* istanbul ignore file */

import Vue from "vue";
import ReadMore from "../components/ReadMore";
import VendorsMap from "../components/VendorsMap";
import store from "../store";
import { mapActions, mapGetters } from "vuex";

const vueEl = "[data-vue-view='vendors-index']";

document.ready.then(() => {
  if (document.querySelector(vueEl)) {
    new Vue({
      el: vueEl,
      store,
      name: "VendorsIndex",
      components: {
        "read-more": ReadMore,
        "store-vendors-map": VendorsMap,
      },
      computed: {
        ...mapGetters({ toggles: "getGlobalToggles" }),
      },
      mounted() {
        window._lytics_.attachEventListeners(this.$el);
      },
      methods: {
        ...mapActions({
          setVendorsMapVisibility: "vendorsIndex/setVendorsMapVisibility",
        }),
        showVendorMap() {
          this.setVendorsMapVisibility(true);
        },
      },
    });
  }
});
